<template>
  <div>
    <form-layout>
      <template slot="maintenance">
        <Maintenance/>
      </template>
      <template slot="heading">
        <!-- eslint-disable-next-line -->
         <!-- <h5>Bloom Client Version 2</h5> -->
        <h5>企業管理画面</h5>
        <!-- <router-link to="/agreement" class="link">
              法人向け利用規約
        </router-link> -->
      </template>
      <login-form/>
    </form-layout>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginForm from '@/components/LoginForm.vue';
import FormLayout from '@/views/FormLayout.vue';
import Maintenance from '../components/Maintenance.vue';
export default {
  name: 'home',
  components: {
    FormLayout,
    LoginForm,
    Maintenance
  },
  mounted() {
    document.getElementsByTagName('body')[0].style.backgroundColor = '#39cecc';
  }
};
</script>
<style scoped>
.link {
    color: #036d6c;
    font-size: 12px;
  }
  .link:hover {
    color: #000;
  }
</style>

